// A fila é da rota-pai (`admin.kyc.tsx`), porque ela continua desenhada embaixo quando a
// submissão abre no drawer (`spec/24` §1 decisão 5). Esta rota-índice existe só para
// `/admin/kyc` ser um destino válido do roteador.

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/kyc/')({ component: () => null });
